import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
    const [showScrollButton, setShowScrollButton] = useState(false);

    // Smooth scroll to top
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Show button only after scrolling down
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setShowScrollButton(true);
            } else {
                setShowScrollButton(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <footer className="footer">
            {/* Curved Top Shape */}
            <div className="footer-shape">
                {/* First Grey Wave */}
                <svg
                    viewBox="0 0 1440 320"
                    xmlns="http://www.w3.org/2000/svg"
                    className="footer-wave"
                >
                    <path
                        fill="url(#greyGradient)"
                        fillOpacity="1"
                        d="M0,128L60,154.7C120,181,240,235,360,240C480,245,600,203,720,170.7C840,139,960,117,1080,128C1200,139,1320,181,1380,202.7L1440,224V0H0Z"
                    ></path>
                    <defs>
                        <linearGradient id="greyGradient" x1="0" x2="1" y1="0" y2="0">
                            <stop offset="0%" stopColor="#d6d1d1ff" /> {/* Light Grey */}
                            <stop offset="100%" stopColor="#d6d1d1ff" /> {/* Dark Grey */}
                        </linearGradient>
                    </defs>
                </svg>

                {/* Second lighter grey wave */}
                <svg
                    viewBox="0 0 1440 320"
                    xmlns="http://www.w3.org/2000/svg"
                    className="footer-wave second"
                >
                    <path
                        fill="#d6d1d1ff"
                        fillOpacity="0.6"
                        d="M0,96L48,128C96,160,192,224,288,224C384,224,480,160,576,154.7C672,149,768,203,864,197.3C960,192,1056,128,1152,96C1248,64,1344,64,1392,64L1440,64V0H0Z"
                    ></path>
                </svg>
            </div>

            {/* Main Footer Content */}
            <div className="footer-content">
                {/* Brand Section */}
                <div className="footer-brand">
                    <img
                        src="/flytutor_logo.png"
                        alt="FlyTutor Logo"
                        className="footer-logo"
                    />
                   <p><strong>Flytutor Technologies Private Limited</strong></p>

                    <br></br>
                    <p>Empowering students with advanced tools to enhance learning outcomes.</p>
                    <br></br>
                    <p>+91 9003992693</p>
                    <p>info@flytutor.com</p>
                    <br></br>
                    <div className="footer-social">
                        <a href="https://www.linkedin.com/company/flytutor-technologies" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                        <a href="https://www.instagram.com/flytutor_rpto" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                        <a href="mailto:info@flytutor.com"><FaEnvelope /></a>
                        <a href="https://www.facebook.com/flytutortechnologies" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                    </div>
                </div>

                {/* Site Map */}
                <div className="footer-links">
                    <br></br>
                    <h4>Site Map</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/course">Courses</Link></li>
                        <li><Link to="/certificate">Certification</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                        <li><Link to="/about">About</Link></li>
                    </ul>
                </div>

                {/* Legal */}
                <div className="footer-links">
                           <br></br>
                    <h4>Legal</h4>
                    <ul>
                        <li><Link to="https://drive.google.com/file/d/1ao9M5IdjVuG-VQn_xH82b0_UxZXjj1Qk/view?usp=drive_link">Privacy Policy</Link></li>
                        <li><Link to="https://drive.google.com/file/d/1VY9lpT8zy65kOibCHfLUTXRsRSLoYklQ/view?usp=drive_link">Terms of Services</Link></li>
                    </ul>
                </div>
            </div>

            {/* Floating Scroll to Top Button */}
            {showScrollButton && (
                <div className="floating-button" onClick={scrollToTop}>
                    ↑
                </div>
            )}

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <p>© 2025 Flytutor Technologies Private Limited. All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
